import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ResultDownloadService {

  constructor(private http: HttpClient) { }

  get(projectId: number, simulationId: any) {
    return this.http.get<any>(`/api/project/${projectId}/simulation/${simulationId}/output`);
  }

  download(projectId: number, simulationId: any, id: number) {
    return this.http.get(
      `/api/project/${projectId}/simulation/${simulationId}/output/${id}/download`,
      {
        responseType: 'blob',
        observe: 'response'
      }
    );
  }

  request(projectId: number, simulationId: any, id: number, params: object) {
    return this.http.post(
      `/api/project/${projectId}/simulation/${simulationId}/output/${id}/request`,
      params
    );
  }

}
